/** PURE_IMPORTS_START .._.._Observable,.._.._operator_do PURE_IMPORTS_END */
import { Observable } from '../../Observable';
import { _do } from '../../operator/do';
Observable.prototype.do = _do;
Observable.prototype._do = _do;
//# sourceMappingURL=do.js.map 



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/add/operator/do.js
// module id = 475
// module chunks = 0